// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"647":"feb3f6b0","787":"c451cc8f"}[chunkId] + ".chunk.js";
};